import { DotLottie } from "@lottiefiles/dotlottie-web";

const lottieLogo = new DotLottie({
	autoplay: true,
	loop: false,
	canvas: document.querySelector('#logo-wave'),
	src: logoObj.lottiesrc,
});